module.exports = __webpack_public_path__ + "img/music-school-icon3.cf27a130.png";